module.exports = __webpack_public_path__ + "static/media/aulaonline.4ac7682b.png";